<template>
  <Success />
</template>

<script>
import Success from '../components/templates/Success'

export default {
  components: {
    Success
  }
}
</script>
